<template>
	<div>
		<label class="switch"> 
			<input type="checkbox" v-model="isChecked">
			<span></span>
		</label>
		
		<div id="tabs">
			<div :class="{'tab':true,'selected':selectedTab==='license'}"
				@click="selectedTab='license'">Lisans</div>
			<div :class="{'tab':true,'selected':selectedTab==='master'}"
				@click="selectedTab='master'">Yüksek Lisans</div>
			<div :class="{'tab':true,'selected':selectedTab==='doctorate'}"
				@click="selectedTab='doctorate'">Doktora</div>
		</div>
		
		<div class="wrap-table">
			<div class="table">
				<div class="row header">
					<div class="cell">Dönem</div>
					<div class="cell">Ders Adı</div>
					<div class="cell">Dil</div>
					<div class="cell">Saat</div>
				</div>

				<div class="row empty-row" v-if="!hideTable">Mevcut Ders Bulunamadı.</div>

				<div class="row"
					v-for="(row, index) in selectedTab==='license'?list.license:selectedTab==='master'? list.master:list.doctorate" :key="index"
					:v-once="row.length>0? hideTable=false:hideTable=true">
						<div class="cell">
							{{row.period}}
						</div>
						<div class="cell">
							{{row.lessonName}}
						</div>
						<div class="cell">
							{{row.language}}
						</div>
						<div class="cell">
							{{row.hours}}
						</div>
				</div>
			</div>
		</div>
	
	</div>
</template>

<script>
	const firebase = require('firebase/app');

	export default {
		name: 'TimeTable',
		data() {
			return {
				selectedTab: 'license',
				isChecked: false,
				hideTable: false,
				list: {},
			}
		},

		created(){
			firebase.database().ref('/TimeTableItem').once('value', snapshot => {
				this.list = snapshot.val();
			});
		}
	}
</script>

<style lang="scss" scoped>
	#tabs{
		display: flex;
		flex-direction: row;
		width: fit-content;
		margin-left: auto;
		margin-right: auto;

		.tab{
			width: 15vw;
			z-index: 3;
			position: relative;
			text-align: center;
			font-size: 18pt;
			padding: 10px;
			margin: 10px 10px 10px 10px;
			border-radius: 20px 20px 10px 10px;
			background-color: white;
			color: #333;
			filter: drop-shadow(0 3px 6px #333);
			transition: 
				filter 1s,
				font-size .5s,
				transform 1s,
				background-color .5s,
				color .5s,
				font-weight .5s,
				font-size .5s;

			@media screen and (max-width: 1024px){
				font-size: 14pt;
				transition: font-size .5s;
			}

			@media screen and (max-width: 768px){
				font-size: 12pt;
				transition: font-size .5s;
			}
		
			&:hover{
				filter: drop-shadow(0 5px 10px #333);
				transition: filter 1s, transform 1s, background-color .5s, color .5s, font-weight .5s;
				z-index: 4;
				cursor: pointer;
			}

			&.selected{
				font-weight: bold;
				background-color: #333;
				color: white;
			}
		}
	}

	//------------------------------ RESPONSIVE TABLE -----------------------
	.wrap-table {
		width: 90%;
		margin: 0 auto 1em auto;
		border-radius: 10px;
		overflow: hidden;
		font-family: "Quicksand";
	}

	.table {
		width: 100%;
		display: table;
		margin: 0;
	}

	@media screen and (max-width: 768px) {
		.table {
			display: block;
		}
	}


	// FIXME: 
	.empty-row{
		display: table-row;
		background-color: #fd6161;
		color: white;
		font-weight: bold;
		text-align: center;
		font-size: 18pt;
		position: relative;
		top: 2em;
		width: 10em;
		border-radius: 0 0 15px 15px;
		padding: 10em;
	}

	.row {
		display: table-row;
		background: #fff;

		&.header {
			color: #ffffff;
			background: #00cc52;
		}
	}

	@media screen and (max-width: 768px) {
		.row {
			display: block;

			&.header {
				padding: 0;
				height: 0px;

				.cell {
					display: none;
				}
			}

			.cell:before {
				font-size: 12px;
				color: #808080;
				line-height: 1.2;
				text-transform: uppercase;
				margin-bottom: 13px;
				content: attr(data-title);
				min-width: 98px;
				display: block;
			}
		}
	}

	.cell {
		display: table-cell;
	}

	@media screen and (max-width: 768px) {
		.cell {
			display: block;
		}
	}

	.row {
		.cell {
			font-size: 15px;
			color: #666666;
			line-height: 1.2;
			padding-top: 20px;
			padding-bottom: 20px;
			border-bottom: 1px solid #f2f2f2;
		}

		&.header .cell {
			font-weight: bold;
			font-size: 18px;
			color: #fff;
			line-height: 1.2;
			padding-top: 19px;
			padding-bottom: 19px;
		}

		.cell {
			&:nth-child(1) {
				width: 20vw;
				padding-left: 40px;
			}

			&:nth-child(2) {
				width: 40vw;
			}

			&:nth-child(3) {
				width: 20vw;
			}

			&:nth-child(4) {
				width: 10vw;
			}
		}
	}

	.table {
		width: 100% !important;
	}

	.row {
		width: 100% !important;

		&:hover {
			cursor: pointer;
		}
	}

	@media (max-width: 768px) {
		.row {
			border-bottom: 1px solid #f2f2f2;
			padding-bottom: 18px;
			padding-top: 30px;
			padding-right: 15px;
			margin: 0;

			.cell {
				border: none;
				padding-left: 30px;
				padding-top: 16px;
				padding-bottom: 16px;

				&:nth-child(1) {
					padding-left: 30px;
				}

				font-size: 18px;
				color: #555555;
				line-height: 1.2;
			}
		}

		.table, .row, .cell {
			width: 100% !important;
		}
	}
	//--------------------------------------------------------------
</style>